import { render, staticRenderFns } from "./redeemCodeList.vue?vue&type=template&id=6056e78c&scoped=true&"
import script from "./redeemCodeList.vue?vue&type=script&lang=js&"
export * from "./redeemCodeList.vue?vue&type=script&lang=js&"
import style0 from "./redeemCodeList.vue?vue&type=style&index=0&id=6056e78c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056e78c",
  null
  
)

export default component.exports